module.exports = "/_next/static/images/desktop_logo-862b83c2afd43eadad0270df13c074c9.svg";